import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Rynco Li
 * id AB226798-9B8A-4929-8880-6665C1114776
 * name card
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card.svg
 * tags
 * - Form 
 */
export const CardIcon = createSvgIcon(<><path d="M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20Z" /></>, 'CardIcon');
export default CardIcon